module.exports = function(fox) {
    'use strict';

    require('./simpleForm')(fox);

    fox.registerWidget('DomForm', {
        configure: function () {
            this.registerOptions('', {
                formSelector: 'form#base-form',
                formPath: '@parent',
                noValidate: false,
                validateOnFly: false
            });

            this.callParent('configure', arguments);
        },

        init: function () {
            this.callParent('init', arguments);

            this.ready = false;
            this._elements = {};
            this._waitForElements = [];

            this.handleEvent(this.getOption('formPath'), 'addedToDom', this.bootstrapForm.bind(this), {
                prefix: [this.getHash(), 'formContainerInDom'].join('_')
            });

            if (this.getOption('handleDom')) {
                fox.each(this.getOption('handleDom'), function (value) {
                    if (!('targetWidget' in value)) {
                        value.targetWidget = this.getOption('formPath');
                    }

                    if (value.event === 'submit' && !('callback' in value)) {
                        value.callback = this.onFormSubmit.bind(this);
                    }
                }, this);
            }
        },

        _addElement: function (type, options) {
            var ElementConstructor;

            if (typeof type === 'function') {
                ElementConstructor = type;
            } else {
                ElementConstructor = this._getBuiltinElementConstructor(type);
            }

            var element = new ElementConstructor(options, this);

            element.init();

            return this._elements[element.key] = element;
        },

        _getBuiltinElementConstructor: function (type) {
            var require__dom__type = require.context('./elements/dom', false, /\.js$/);
            var require__type = require.context('./elements', false, /\.js$/);

            var module;

            function get (req, type) {
                var m = req('./' + type + '.js');

                return m(fox);
            }

            try {
                module = get(require__dom__type, type);
            } catch (e) {} finally {
                if (!module) module = get(require__type, type);

                return module;
            }
        },

        _getFormControls: function () {
            var node = this.getFormDomNode();
            var controlsSelectors = [
                'button', 'datalist', 'meter', 'progress',
                'input', 'select', 'textarea'
            ];

            return node && (node.elements || node.querySelectorAll(controlsSelectors.join(',')));
        },

        _checkFormNoValidate: function () {
            var node = this.getFormDomNode();
            var noValidate = false;

            if (node && node.nodeName.toLowerCase() === 'form') {
                if (this.getOption('noValidate') && !node.noValidate) {
                    node.noValidate = noValidate = true;
                } else if (node.noValidate) {
                    this.setOption('noValidate', (noValidate = true));
                }
            }

            return noValidate;
        },

        _dispatchFormReady: function () {
            this.ready = true;

            this.dispatchEvent('internal_form_ready');
            this.dispatchEvent('form_ready');
        },

        deactivate: function () {
            this.ready = false;

            this.callParent('deactivate', arguments);
        },

        elementToWait: function (promise) {
            this._waitForElements.push(promise);

            return this;
        },

        bootstrapForm: function () {
            var elementsOption = fox.clone(this.getOption('elements') || {});
            var noValidate = this._checkFormNoValidate();
            var validateOnFly = this.getOption('validateOnFly');

            function getWaitPromise (widget, params) {
                return new fox.Promise(function (resolve, reject) {
                    var timer = setTimeout(reject.bind(null, params), 5000);
                    
                    return widget.wait('@this', 'addedToDom', {
                        prefix: 'waitWomContainer'
                    }).then(function (resp) {
                        clearTimeout(timer);

                        return resolve(resp);
                    });
                }.bind(this));
            }

            function runElement (elementNode, name) {
                if (!name) return false;
                
                name = name.replace(/^(\w+)__\w+$/, '$1');

                var element = this.getElement(name);
                var widget;

                if (element) {
                    if (element.womContainer) {
                        widget = element.womContainer;

                        if (!widget || !widget.isEmbedded()) {
                            return this.elementToWait(getWaitPromise.call(this, widget, element.params).then(function () {
                                element.init();

                                return element.params.name;
                            }));
                        }
                    }

                    return element.init();
                } else {
                    var elementOptions = this.getOption('elements.' + name) || {};

                    elementOptions.name = name;

                    if (noValidate) {
                        elementOptions.noValidate = noValidate;
                    } else if (validateOnFly) {
                        if (!('validateOnFly' in elementOptions)) {
                            elementOptions.validateOnFly = validateOnFly;
                        }
                    }

                    if (!('selector' in elementOptions)) {
                        elementOptions.selector = '[name="' + name + '"]';
                    }

                    if ('womContainer' in elementOptions) {
                        widget = this.wom1(elementOptions.womContainer);

                        if (!widget || !widget.isEmbedded()) {
                            return this.elementToWait(getWaitPromise.call(this, widget, elementOptions).then(function (resp) {
                                var node = resp.performer.dom1(elementOptions.selector);

                                if (!('type' in elementOptions) && fox.dom.isDomNode(node)) {
                                    elementOptions.type = node.nodeName.toLowerCase();
                                }

                                this._addElement(elementOptions.type, elementOptions);

                                return elementOptions.name;
                            }.bind(this)))
                        }
                    }

                    if (!('type' in elementOptions) && fox.dom.isDomNode(elementNode)) {
                        elementOptions.type = elementNode.nodeName.toLowerCase();
                    }

                    return this._addElement(elementOptions.type, elementOptions);
                }
            }

            fox.each(this._getFormControls(), function (node) {
                var name = node.name;

                try {
                    runElement.call(this, node, name);
                } catch (e) {
                    fox.exception(e);
                } finally {
                    delete elementsOption[name];
                }
            }, this);

            fox.each(elementsOption, runElement, this);

            if (this._waitForElements.length) {
                return fox.Promise.all(this._waitForElements).then(function () {
                    this._waitForElements = [];

                    return this._dispatchFormReady();
                }.bind(this)).catch(function (resp) {
                    this._waitForElements = [];

                    var alias = fox.isString(resp.womContainer) ?
                        resp.womContainer :
                        '@' + resp.womContainer.getId() + '#' + resp.womContainer.getAlias()

                    console.error([
                        'Problem with element: "' + resp.name + '".',
                        'Reason: womContainer with value "' + alias + '" not embedded.'
                    ].join('\n'));
                }.bind(this));
            }

            return this._dispatchFormReady();
        },

        addElement: function () {
            var formContainer = this.rwom1(this.getOption('formPath'));

            if (!formContainer.isEmbedded()) {
                throw new Error('Form container not exists in DOM tree.');
            }

            return this._addElement.apply(this, arguments);
        },

        removeElement: function (key) {
            return delete this._elements[key];
        },

        /**
         * Set value for element
         * @param {string} field
         * @param {any} value
         * @param {boolean} broadcast - true - dispatchEvent('change') for this field
         */
        setValue: function (field, value, broadcast) {
            var element = this.getElement(field);

            return element &&
                !element.skip &&
                element.setValue(value, broadcast);
        },

        /**
         * Set values
         * @param {Object} values
         */
        setValues: function (values) {
            fox.each(values || {}, function (value, key) {
                return this.setValue(key, value);
            }, this);
        },

        /**
         * Returns value for field
         * @param {string} field
         * @returns {boolean|string|Promise}
         */
        getValue: function (field) {
            var element = this.getElement(field);

            return element && element.getValue();
        },
        
        /**
         * Returns all fields values
         * @returns {Object|Promise}
         */
        getValues: function () {
            var elements = this._elements;

            function fillValues (prev, key, value) {
                prev.values[key] = value;

                return value;
            }

            var values = fox.getObjectKeys(elements).reduce(function (prev, next) {
                if (elements[next].skip) return prev;

                var value = elements[next].getValue();

                if (!('async' in prev) && fox.isPromise(value)) {
                    prev.async = value.then(function (value) {
                        return fillValues(prev, next, value);
                    });
                } else if ('async' in prev) {
                    prev.async = prev.async.then(function () {
                        return fox.isPromise(value) ? value : fox.Promise.resolve(value);
                    }).then(function (value) {
                        return fillValues(prev, next, value);
                    });
                } else {
                    prev.values[next] = value;	
                }

                return prev;
            }, {values: {}});

            if ('async' in values) return values.async.then(function () {
                return values.values;
            });

            return values.values;
        },

        /**
         * Returns element instance
         * @param {string} field
         * @returns {boolean|FormElementBase}
         */
        getElement: function (name) {
            return name in this._elements && this._elements[name];
        },

        /**
         * Reset all fields to initial value
         */
        reset: function () {
            fox.each(this._elements, function (element) {
                return element.reset();
            });
        },

        /**
         * Check for form disabling
         * @returns {boolean}
         */
        isDisabled: function () {
            return fox.getObjectKeys(this._elements).every(function (field) {
                return this.getElement(field).disabled;
            }, this);
        },

        _toggleDisabled: function (field, method) {
            var element = this.getElement(field);

            if (element) {
                var promise = this.wait('@this', method + 'd_' + field, {
                    prefix: ['internal', 'toggle', 'disable'].join('_')
                }).then(function () {
                    return this.dispatchEvent(method + 'd', [field]);
                }.bind(this));

                element[method]();

                return promise;
            } else if (!fox.isUndefined(field)) {
                return false;
            }

            return fox.Promise.all(fox.getObjectKeys(this._elements).map(function (field) {
                var element = this.getElement(field);
                var promise = this.wait('@this', method + 'd_' + field, {
                    prefix: ['internal', 'toggle', 'disable'].join('_')
                }).then(function () {
                    return field;
                });

                element[method]();

                return promise;
            }, this)).then(function (fields) {
                return this.dispatchEvent(method + 'd', fields);
            }.bind(this));
        },

        /**
         * Disable all or one element
         * @param {string} [field]
         * @returns {Promise}
         */
        disable: function (field) {
            return this._toggleDisabled(field, 'disable');
        },

        /**
         * Enable all or one element
         * @param {string} [field]
         * @returns {Promise}
         */
        enable: function (field) {
            return this._toggleDisabled(field, 'enable');
        },

        onFormSubmit: function (form, alias, w, e) {
            fox.dom.event.stop(e);

            this.submit();

            return false;
        },

        /**
         * Returns form dom node
         * @returns {DomNode}
         */
        getFormDomNode: function () {
            return this.getFormContainer().dom1(this.getOption('formSelector'));
        },

        /**
         * Returns form container widget
         * @returns {FoxBaseObject}
         */
        getFormContainer: function () {
            return this.rwom1(this.getOption('formPath'));
        },

        /**
         * Main method for recieving values
         * @return {Promise<Object>}
         */
        submit: function () {
            var args = [this.getValues()].concat(fox.clone(arguments));

            if (!this.getOption('noValidate')) {
                return this.validate().then(function (isValid) {
                    return isValid && this.callParent('submit', args);
                }.bind(this));
            }

            return this.callParent('submit', args);
        },

        /**
         * Validate form
         * @returns {Promise<boolean>}
         */
        validate: function () {
            return fox.Promise.all(fox.getObjectKeys(this._elements).map(function (key) {
                var result = this._elements[key].validate();

                return fox.isPromise(result) && result || fox.Promise.resolve(result);
            }, this)).then(function (results) {
                var isValid = results.every(function (result) {return result.result === true;});

                this.dispatchEvent(!isValid ? 'form_not_valid' : 'form_valid', results);

                return isValid;
            }.bind(this));
        }

    }, 'SimpleForm');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/domForm.js
// module id = 216
// module chunks = 0